import httpClient from "http-client/http-client";

export async function fetchCommunitySummary({ vendor_id, community_id }) {
  const body = { vendor_id, ...(community_id ? { community_id } : {}) };
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/analytics/community-summary",
    body,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function fetchVendorOrders(body = {}) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/orders-and-bookings/orders/vendor",
    body,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function getOrderDetail(order_number) {
  const { data, errors } = await httpClient.get({
    url: `v1/community-portal/orders-and-bookings/orders/${encodeURIComponent(order_number)}`,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function fetchBookingsList(params = {}) {
  const { data, errors } = await httpClient.get({
    url: "v1/community-portal/orders-and-bookings/bookings/list",
    params,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}

export async function getBookingDetail(booking_number) {
  const { data, errors } = await httpClient.get({
    url: `v1/community-portal/orders-and-bookings/bookings/${encodeURIComponent(booking_number)}/details`,
  });
  if (errors?.length) return { data: null, errors };
  return { data };
}
